module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Bold.e327f8e.woff2";